module.exports = require("./fr-CH.js");